{
  "facility.name": "Helsinki Airport drop-off area",
  "facility.webpage.url": "https://www.finavia.fi/en",
  "facility.customerService.url": "https://customerservice.finavia.fi/en/support/home",
  "facility.privacyPolicy.url": "https://www.finavia.fi/fi/media/7837/download",
  "facility.privacyPolicy.text": "Privacy policy",

  "document.title": "Helsinki Airport drop-off",

  "page.webPayment.paymentProvider.heading": "Payment Service Provider",
  "page.webPayment.paymentProvider.information": "Paytrail Oyj is a collecting payment service provider and an authorized Payment Institution working in cooperation with Finnish banks and credit institutions. Paytrail Oyj will be shown as the recipient on your bank or credit card statement. Paytrail Oyj will forward the payment to the merchant. For complaints, please contact the website the payment was made to.",
  "page.webPayment.paymentProvider.details1": "Paytrail Oyj, Business ID 2122839-7",
  "page.webPayment.paymentProvider.details2": "Innova 2",
  "page.webPayment.paymentProvider.details3": "Lutakonaukio 7",
  "page.webPayment.paymentProvider.details4": "40100 Jyväskylä",
  "page.webPayment.paymentProvider.url": "https://www.paytrail.com/en/consumer/information-about-paying",

  "page.webPayment.stepFillLicensePlate.info.pay": "Pay for your visit within 48 hours",
  "page.webPayment.stepFillLicensePlate.info.notPaid": "Did you visit Helsinki Airport's drop-off area and have not yet paid?",
  "page.webPayment.stepFillLicensePlate.info.licensePlate": "Search for your visit details by entering your vehicle's registration number:",
  "page.webPayment.stepFillLicensePlate.button.find": "Search for the vehicle",
  "page.webPayment.stepFillLicensePlate.formLicensePlate.label.licensePlate": "Registration number",
  "page.webPayment.stepFillLicensePlate.formLicensePlate.label.enter": "Enter",
  "page.webPayment.stepFillLicensePlate.formLicensePlate.errors.licensePlate": "Enter a valid vehicle registration number.",
  "page.webPayment.stepFillLicensePlate.formLicensePlate.info.format": "In the format ABC-123 or ABC123",
  "page.webPayment.stepFillLicensePlate.alert.title.noUnpaidParkingEvents": "No unpaid visits were found for the registration number {licensePlate}.",
  "page.webPayment.stepFillLicensePlate.alert.body.reason": "This can be due to various reasons.",
  "page.webPayment.stepFillLicensePlate.alert.body.desc1": "Your visit to the drop-off area was free of charge",
  "page.webPayment.stepFillLicensePlate.alert.body.desc2": "48 hours have passed since the visit and a bill or payment reminder has been sent by mail based on the registration number",
  "page.webPayment.stepFillLicensePlate.alert.body.desc3": "You entered the wrong registration number",
  "page.webPayment.stepFillLicensePlate.getInvoice.errorToast": "Error while fetching data. Please try again later.",

  "page.webPayment.stepInvoice.info.invoice": "Your payments",
  "page.webPayment.stepInvoice.info.invoiceDescription": "{count, plural, one {One unpaid visit was found with the registration number {licensePlate}.} other {{count} unpaid visits were found with the registration number {licensePlate}.}}",
  "page.webPayment.stepInvoice.button.payParking": "Pay",
  "page.webPayment.stepInvoice.button.payParking.loading": "Loading...",
  "page.webPayment.stepInvoice.cardInvoice.parkingStarted": "Visit start time",
  "page.webPayment.stepInvoice.cardInvoice.duration": "Duration",
  "page.webPayment.stepInvoice.cardInvoice.parkingPrice": "Visit fee",
  "page.webPayment.stepInvoice.cardInvoice.vatIncluded": "Incl. {vat}% VAT {vatPrice}",
  "page.webPayment.stepInvoice.contactInformation.description": "Your email address is required for the receipt and the possible refund.",
  "page.webPayment.stepInvoice.emailAddress": "Email address",
  "page.webPayment.stepInvoice.form.email.errors.email": "Please enter a valid email address.",
  "page.webPayment.stepInvoice.form.email.errors.required": "Email address is required.",
  "page.webPayment.stepInvoice.error.initiatePayment": "Error while initiating payment. Please try again later.",

  "page.webPayment.stepFinish.info.success": "Payment completed. Thank you!",
  "page.webPayment.stepFinish.info.failure": "Payment failed.",
  "page.webPayment.stepFinish.failureInfo": "The payment may have failed due to various reasons.",
  "page.webPayment.stepFinish.failureInfoList.heading": "Possible reasons include",
  "page.webPayment.stepFinish.failureInfoList.item1": "You cancelled the payment",
  "page.webPayment.stepFinish.failureInfoList.item2": "Insufficient bank account balance",
  "page.webPayment.stepFinish.failureInfoList.item3": "Credit limit on the credit card",
  "page.webPayment.stepFinish.failureInfoList.item4": "Connection problem between the bank and the payment service",
  "page.webPayment.stepFinish.failureInfoList.item5": "Online payment restrictions on the payment card",
  "page.webPayment.stepFinish.failureInfoList.footer": "If necessary, please contact your bank.",
  "page.webPayment.stepFinish.info.receipt": "Your receipt will be sent to {email}.",
  "page.webPayment.stepFinish.button.newPayment": "Pay for another visit",
  "page.webPayment.stepFinish.button.tryAgain": "Try again",
  "page.webPayment.stepFinish.backToFacilitySiteButtonText": "Finavia.fi/en",

  "page.webPayment.paymentRedirectReceiver.heading": "Processing payment...",

  "page.webPayment.label.customerService.part1": "If you have any problems, please contact",
  "page.webPayment.label.customerService.part2": "Finavia's customer service",
  "page.webPayment.label.customerService.urlTitle": "Finavia's customer service",

  "common.units.hours.short": "h",
  "common.units.minutes.short": "min",
  "common.units.seconds.short": "s",
  "common.button.back": "Back",
  "language": "Language",
  "language.fi": "Suomeksi",
  "language.en": "In English",
  "language.sv": "På svenska"
}
